import _ from 'lodash';
import React from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { initiateCall } from '../../base/callService/callService';
import { toastInformation } from '../../base/callService/common';
import { storeHoldTeam } from '../../base/callService/store_mining';
import { initialStateModel } from '../../models/model';
import styles from "./scss/contact-details.module.scss";
import ContactTeamsSingle from "../contacts/contactWidgets/contactTeams/contactlistSingle"
export default function ContactUserDetails() {
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let { contactWindowDetails } = allReducer.contactWindowReducer;
  let newCallUpdatedCallList: any = allReducer.updatedCallList
  let history = useHistory();

 const sendGMail =async(data:any) =>{
  try{
  var subject=`Worktual`;
  var altDescription:any = "";
  var recipients:any=data?.email_id;
  const generateURL = encodeURI(`https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&su=${subject}&body=${altDescription}&to=${recipients} `);
  window.open(generateURL, '_blank');
}
catch (error) {
  console.log("error", error);
}
}

const startCallInitate = (data: any) => {
  if (history.location.pathname !== 'calls' && _.isEmpty(newCallUpdatedCallList.callDetails)) {
    history.push('/calls');
    data?.ext && initiateCall(data.ext, "audio");
  }
  else {
    if (newCallUpdatedCallList.callDetails[0].holdState === true) {
      data?.ext && initiateCall(data.ext, "audio");
    } else {
      toastInformation("future implementation");
    }
  }
}


  //console.log(contactWindowDetails,"contactWindowDetails")
  return (
    <>
    {contactWindowDetails.team_id?
    <div>
    <ContactTeamsSingle />
    </div>:
     <div className={styles.userDetails}>
      <div className={`${styles.dataTitle} ${styles.listarrange}`}>
        <div>
        <span>Extension</span>
        <span className={styles.callIcon}  onClick={()=>startCallInitate(contactWindowDetails)}>{contactWindowDetails?.ext}</span>
        </div>
        <div>
        <span>Department</span>
        <span className={styles.blackclrs}>{contactWindowDetails?.department}</span>
        </div>
        <div>
        <span>Company Number</span>
        <span>{contactWindowDetails?.direct_no}</span>
        </div>
        <div>
        <span>Worktual Number</span>
        <span>{contactWindowDetails?.cli}</span>
        </div>
        <div><span>Mobile number</span>
        <span onClick={()=>initiateCall(contactWindowDetails?.mobileno,"audio")}>{contactWindowDetails?.mobileno}</span></div>
        <div>
        <span>International Number</span>
        <span></span>
        </div>
        <div>
        <span>Email (Home)</span>
        <span className={styles.sendGMail} onClick={()=>sendGMail(contactWindowDetails)} >{contactWindowDetails?.email_id}</span>
        </div>
        <div>
        <span>Email (Work)</span>
        <span className={styles.sendGMail} onClick={()=>sendGMail(contactWindowDetails)}>{contactWindowDetails?.email_id}</span>
        </div>
      </div>
    </div> }
    
    </>
  )
}
